export default __webpack_public_path__ + "static/media/stats75.d2f73b4f.png";